import Firebase from 'firebase/app'
import { newsletterCollection } from './firebase'

export function subscribeNewsletter(email) {
  return newsletterCollection.doc(email).set({
    email,
    createdAt: Firebase.firestore.FieldValue.serverTimestamp(),
  })
}
